import React from 'react';
import HelpSystemInformation from '@lib/components/common/HelpSystemInformation';

import FieldSingleSearchDropdown from '../../edit-page/fields/FieldSingleSearchDropdown';

export default class SparePartsFinderTextSearchFilterPanel extends React.Component {
    render() {
        return (
            <div className="index-table-filters-panel filter-configuration-id">
                <div className="filters-panel-row filters-panel-active-filters">
                    <div className="filters-panel-active-filters-left">
                        <div className="filters-panel-caption">{this.getCaption()}</div>
                        {this.renderSearchParameter()}
                    </div>
                </div>
            </div>
        )
    }

    renderSearchParameter = () => {
        const searchParameterFilter = this.props.filters.find(x => x.meta.slug === 'SearchParameter');
        const field = {
            items: searchParameterFilter.items,
            value: searchParameterFilter.model
        }

        return (
            <div className="text-search-filter-container">
                <FieldSingleSearchDropdown field={field} onOptionClick={this.onSearchParameterChange}/>
                <HelpSystemInformation text={__('This filter is only valid for units configured in WebSelect')}/>
            </div>
        )
    }

    onSearchParameterChange = id => {
        if (id === 0) {
            return;
        }

        this.props.onFilterChange('SearchParameter', id)
    }

    getCaption() {
    }
}